import { useApi } from 'api/useApi';
import { ENV_VARS } from 'app/config/environment-vars';

import type { CreateImportPayload, ImportRunResult, ImportValueModel } from './types';

const IMPORTS_V2_ERROR_KEY = 'DataApiClient';

export const useImportsApi = () => {
  const baseURL = `${ENV_VARS.DATA_URL}/api`;
  const fetchFunction = useApi(baseURL, IMPORTS_V2_ERROR_KEY);

  const getAll = (projectId: string) => fetchFunction<ImportValueModel[]>(`imports/runs/?projectId=${projectId}`);

  const get = (importId: string) => fetchFunction<ImportValueModel>(`imports/runs/${importId}`);

  const getRunResult = (importId: string) => fetchFunction<ImportRunResult>(`imports/runs/${importId}/results`);

  const create = (payload: CreateImportPayload) => {
    const formData = new FormData();
    formData.append('projectId', payload.projectId);
    formData.append('mappingId', payload.mappingId);
    formData.append('file', payload.file);
    return fetchFunction<ImportValueModel>(`/imports/runs`, {
      method: 'POST',
      body: formData
    });
  };

  const cancel = (importId: string) => {
    return fetchFunction(`imports/runs/${importId}/cancel`, {
      method: 'PATCH'
    });
  };

  const remove = (importId: string) => {
    return fetchFunction(`imports/runs/${importId}`, {
      method: 'DELETE'
    });
  };

  const runImport = (importId: string, proposalId?: string) => {
    const query = proposalId ? `?proposalId=${proposalId}` : '';
    return fetchFunction(`v2/imports/runs/${importId}/run${query}`, {
      method: 'POST'
    });
  };

  const runDryRun = (importId: string, proposalId?: string) => {
    const query = proposalId ? `?proposalId=${proposalId}` : '';
    return fetchFunction(`v2/imports/runs/${importId}/dry-run${query}`, {
      method: 'POST'
    });
  };

  return {
    getAll,
    get,
    create,
    cancel,
    remove,
    runImport,
    runDryRun,
    getRunResult
  };
};
